import type {
  AxiosError,
  AxiosInstance,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios';

import Logging from 'services/logging';

const onRequest = (
  config: InternalAxiosRequestConfig,
): InternalAxiosRequestConfig => {
  const storageToken = window.localStorage.getItem('token');
  // eslint-disable-next-line no-param-reassign
  config.headers.set('Authorization', `Bearer ${storageToken ?? ``}`);
  config.headers.set('Document-Policy', 'js-profiling');
  return config;
};

const onRequestError = (error: AxiosError): Promise<AxiosError> => {
  Logging.logError(error);
  return Promise.reject(error);
};

const onResponse = (response: AxiosResponse): AxiosResponse => {
  return response;
};

const onResponseError = (error: AxiosError): Promise<AxiosError> => {
  Logging.logError(error);
  return Promise.reject(error);
};

export const setupInterceptorsTo = (
  axiosInstance: AxiosInstance,
): AxiosInstance => {
  axiosInstance.interceptors.request.use(onRequest, onRequestError);
  axiosInstance.interceptors.response.use(onResponse, onResponseError);
  return axiosInstance;
};
